import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const orderApi = createApi({
  reducerPath: "orderApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().user.token;
      if (token) {
        headers.set("authorization", token);
      }
      return headers;
    },
  }),
  tagTypes: ["Order"],
  endpoints: (builder) => ({
    updateServiceConfig: builder.mutation({
      query: ({ serviceId, ...data }) => ({
        url: `/v1.0/external/orders/update-service-config/${serviceId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Order"],
    }),
    getOrder: builder.query({
      query: (id) => `/v1.0/external/bom/${id}`,
      transformResponse: (response) => response.data,
      providesTags: ["Order"],
    }),
  }),
});

export const { useGetOrderQuery, useUpdateServiceConfigMutation } = orderApi;
